import React, { Component } from "react";
import Helmet from "react-helmet";
import "css/index.css";
import "css/bootstrap-grid.css";
import "css/bootstrap-table.css";
import "css/typography.scss";
import "css/spacings.scss";
import RotatingSvgsManager from "managers/RotatingSvgsManager";
import cardTw from "assets/card-tw.png";
import CookieBanner from "../components/CookieBanner";
import ContactForm from "../components/ContactForm";
import { connect } from "react-redux";
import { get } from "lodash";
import android36 from "assets/favicons/android-icon-36x36.png";
import android48 from "assets/favicons/android-icon-48x48.png";
import android72 from "assets/favicons/android-icon-72x72.png";
import android96 from "assets/favicons/android-icon-96x96.png";
import android144 from "assets/favicons/android-icon-144x144.png";
import android192 from "assets/favicons/android-icon-192x192.png";
import apple from "assets/favicons/apple-icon.png";
import apple57 from "assets/favicons/apple-icon-57x57.png";
import apple60 from "assets/favicons/apple-icon-60x60.png";
import apple72 from "assets/favicons/apple-icon-72x72.png";
import apple76 from "assets/favicons/apple-icon-76x76.png";
import apple114 from "assets/favicons/apple-icon-114x114.png";
import apple120 from "assets/favicons/apple-icon-120x120.png";
import apple144 from "assets/favicons/apple-icon-144x144.png";
import apple152 from "assets/favicons/apple-icon-152x152.png";
import apple180 from "assets/favicons/apple-icon-180x180.png";
import applePrecomposed from "assets/favicons/apple-icon-precomposed.png";
import favicon from "assets/favicons/favicon.ico";
import favicon16 from "assets/favicons/favicon-16x16.png";
import favicon32 from "assets/favicons/favicon-32x32.png";
import favicon96 from "assets/favicons/favicon-96x96.png";
import msicon70 from "assets/favicons/ms-icon-70x70.png";
import msicon144 from "assets/favicons/ms-icon-144x144.png";
import msicon150 from "assets/favicons/ms-icon-150x150.png";
import msicon310 from "assets/favicons/ms-icon-310x310.png";

const mapStateToProps = state => ({
    contactFormOpen: get(state, "contactFormOpen")
});

class Layout extends Component {
    constructor(props) {
        super(props);
        this.rotatingSvgsManager = new RotatingSvgsManager();
    }

    componentDidMount() {
        this.rotatingSvgsManager.init();
        this.rotatingSvgsManager.start();
    }

    componentDidUpdate() {
        document.body.classList.remove("noscroll");
        this.rotatingSvgsManager.restart();
    }

    componentWillUnmount() {
        this.rotatingSvgsManager.destroy();
    }

    render() {
        const { children, contactFormOpen } = this.props;
        return (
            <div>
                <Helmet
                    titleTemplate={`iGenius - %s`}
                    meta={[
                        { name: "author", content: "igenius.ai" },
                        { property: "og:site_name", content: "igenius.ai" },
                        {
                            property: "og:image",
                            content: "https://igenius.ai/iGenius.png"
                        },
                        {
                            name: "twitter:card",
                            content: "summary_large_image"
                        },
                        { name: "twitter:site", content: "@iGeniusAI" },
                        {
                            name: "twitter:image:src",
                            content: cardTw
                        }
                    ]}
                    link={[
                        { rel: 'icon', type: 'image/png', sizes: "36x36", href: `${android36}` },
                        { rel: 'icon', type: 'image/png', sizes: "48x48", href: `${android48}` },
                        { rel: 'icon', type: 'image/png', sizes: "72x72", href: `${android72}` },
                        { rel: 'icon', type: 'image/png', sizes: "96x96", href: `${android96}` },
                        { rel: 'icon', type: 'image/png', sizes: "144x144", href: `${android144}` },
                        { rel: 'icon', type: 'image/png', sizes: "192x192", href: `${android192}` },
                        { rel: 'icon', type: 'image/png', href: `${apple}` },
                        { rel: 'icon', type: 'image/png', sizes: "57x57", href: `${apple57}` },
                        { rel: 'icon', type: 'image/png', sizes: "60x60", href: `${apple60}` },
                        { rel: 'icon', type: 'image/png', sizes: "72x72", href: `${apple72}` },
                        { rel: 'icon', type: 'image/png', sizes: "76x76", href: `${apple76}` },
                        { rel: 'icon', type: 'image/png', sizes: "114x114", href: `${apple114}` },
                        { rel: 'icon', type: 'image/png', sizes: "120x120", href: `${apple120}` },
                        { rel: 'icon', type: 'image/png', sizes: "144x144", href: `${apple144}` },
                        { rel: 'icon', type: 'image/png', sizes: "152x152", href: `${apple152}` },
                        { rel: 'icon', type: 'image/png', sizes: "180x180", href: `${apple180}` },
                        { rel: 'icon', type: 'image/png', href: `${applePrecomposed}` },
                        { rel: 'icon', type: 'image/ico', href: `${favicon}` },
                        { rel: 'icon', type: 'image/png', sizes: "16x16", href: `${favicon16}` },
                        { rel: 'icon', type: 'image/png', sizes: "32x32", href: `${favicon32}` },
                        { rel: 'icon', type: 'image/png', sizes: "96x96", href: `${favicon96}` },
                        { rel: 'icon', type: 'image/png', sizes: "70x70", href: `${msicon70}` },
                        { rel: 'icon', type: 'image/png', sizes: "144x144", href: `${msicon144}` },
                        { rel: 'icon', type: 'image/png', sizes: "150x150", href: `${msicon150}` },
                        { rel: 'icon', type: 'image/png', sizes: "310x310", href: `${msicon310}` },
                    ]}
                    htmlAttributes={
                      {
                        lang: "en",
                        prefix: "og: http://ogp.me/ns#",
                        class: contactFormOpen && "noscroll"
                      }
                    }

                />
                <div>{children()}</div>
                <ContactForm />
                <CookieBanner />
            </div>
        );
    }
}

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/layouts/index.js